export default "__VITE_PUBLIC_ASSET__d5ad9ec9__"